<template>
  <a-layout class="bank-account">
    <div class="bank-account-content">
      <a-button type="default" class="go-back" @click="goBack">
        <a-icon type="left" />
        Regresar
      </a-button>

      <a-spin :spinning="submitting" :tip="labels.submittingText">
        <div class="content-base container">
          <a-card class="transaction-form-card" id="transaction-print-area">
            <a-divider orientation="left" class="text-white" type="horizontal">
              {{ labels.bankInfoLabel }}
            </a-divider>
            <validation-provider
              vid="account"
              name="Cuenta bancaria"
              rules="required"
            >
              <user-bank-account-component
                slot-scope="{ errors }"
                v-model="bankAccount"
                :labels="labels"
                :error="errors[0]"
              />
            </validation-provider>
          </a-card>
        </div>
      </a-spin>
    </div>
  </a-layout>
</template>
<script>
import loadingMixin from "@/mixins/loadingMixin";
import labels from "@/utils/labels";
import { ValidationProvider } from "vee-validate";
import UserBankAccountComponent from "@/components/UserBankAccountComponent.vue";
export default {
  name: "BankAccount",
  mixins: [loadingMixin],
  components: {
    ValidationProvider,
    UserBankAccountComponent,
  },
  data() {
    return {
      bankAccount: null,
      labels: {
        ...labels.transactionForm,
        appName: labels.appName,
      },
      submitting: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variable";

.bank-account {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;

  .bank-account-content {
    padding: 10px;
    color: var(--white);

    .go-back {
      background: transparent !important;
      color: var(--btn-bg-primary);
      border-color: var(--btn-bg-primary);
      margin-bottom: 10px;
    }

    .content-base {
      padding: 0;
      max-width: 100%;
    }
  }

  @media screen and (max-width: $screen-mobile) {
    max-width: 100% !important;
  }
  .text-white {
    color: var(--text);
  }

  ::v-deep .transaction-form-card {
    background-color: var(--card-bg);
    border-color: var(--white);
    padding: 1.125rem;
    border-radius: 10px;
    @media screen and (max-width: $screen-mobile) {
      padding: 2.125rem 1rem;
      width: 100%;
    }
    &-title {
      font-size: 1.5rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
      line-height: 1.2;
      &.small {
        font-size: 1rem;
      }
    }
    &-subtitle {
      font-size: 1.125rem;
      font-weight: 500;
      margin-bottom: 20px;
      color: var(--text);
      text-align: center;
    }
    &-label {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
    }
    &-value {
      font-size: 1.125rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
      border-bottom: 1px dotted var(--text-muted);
    }
    &-total-label {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
    }
    &-total-value {
      font-size: 1.125rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
      border-bottom: 1px dashed var(--text);
    }
  }

  ::v-deep .ant-form label {
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  ::v-deep .ant-input-number,
  ::v-deep .ant-input {
    background-color: var(--input-bg);
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-active);
    }
  }
  ::v-deep .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-textarea-clear-icon,
    .ant-input-password-icon {
      color: var(--text);
    }
  }
  ::v-deep .has-error .ant-input-affix-wrapper .ant-input,
  ::v-deep .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: color(c-primary);
  }
  ::v-deep .ant-select {
    .ant-select-selection--single {
      color: var(--text);
      background-color: var(--input-bg);
      border: 1px solid var(--text-active);
      &:active,
      &:focus,
      &:hover {
        border-color: var(--text-active);
      }
      .anticon-down {
        color: var(--text);
      }
    }
  }
}

.light {
  .profile {
    .content {
      ::v-deep .ant-tabs-tab {
        color: #000000 !important;

        &.ant-tabs-tab-active {
          color: #1890ff !important;
        }
      }

      ::v-deep .ant-tabs-tab-prev-icon {
        color: black;
      }
      ::v-deep .ant-tabs-tab-next-icon {
        color: black;
      }
    }
    .text-white {
      color: #333333;
    }
  }
}
</style>
